import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgImgTriangleWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 80,
	height: 38,
	viewBox: "0 0 56 28",
	fill: "white",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M30.4909 26.3989C29.0344 27.555 26.9734 27.555 25.517 26.3989L2.27067 7.94561C-0.696732 5.59004 0.968933 0.81271 4.75762 0.81271L51.2502 0.81271C55.0389 0.81271 56.7045 5.59004 53.7371 7.94561L30.4909 26.3989Z" })
});
export default SvgImgTriangleWhite;
